import type { UseQueryHookResult } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { QueryEffect } from '@helpers/QueryEffect';
import { useAlert } from '@hooks/useAlert';

type SystemTableEffectsProps = {
    mode: string;
    queries: UseQueryHookResult<any>[];
};

export const SystemTableEffects = ({ queries, mode }: SystemTableEffectsProps) => {
    const { setAlert } = useAlert();

    return (
        <>
            {queries.map((queryState, index) => (
                <QueryEffect
                    key={`${index}-system-table-effect`}
                    queryState={queryState}
                    effects={{
                        isError: () => {
                            setAlert(`Failed to fetch ${mode} systems data`, 'error');
                        },
                    }}
                />
            ))}
        </>
    );
};
